import { Fragment } from 'react';
import {useTranslation} from 'react-i18next';
// import {Link} from 'react-router-dom';

const CompleteRequest = () => {
  const {t: translate } = useTranslation();
  return (
    <Fragment>
      <h4 className="input-container__heading input-container__heading--centre">
        {translate('password-reset')}
      </h4>
      {/* <Link to="/" className="button">Return to login screen</Link> */}
    </Fragment>
  );
};

export default CompleteRequest;
